export const GET_PAYPAL_ORDER_QUERY = `
  query PaymentQuery {
    paypalOrder {
      data {
        payPalOrderId
        orderStatus
        orderInfo {
          customer {
            firstName
            lastName
            shippingAddress {
              city
              countryCode
              houseNumberOrName
              stateProvince
              streetName
              zipCode
              email
              phone            
            }
          }
        }
      }
      messages
    }
  }
`;
